export const ACTIONS_SITE = {
  INVALIDATE: 'SITES_INVALIDATE',
  RECEIVE: 'SITES_RECEIVE',
  DELETE: 'SITE_DELETE',
  UPDATE: 'SITE_UPDATE',
};

const siteConstants = {};

export default siteConstants;
